import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';

import { AuthenticationService } from '../../../../app/services/authentication.service';
import { AlertService } from '../../../../app/utils/alert.service';
import {  Router, NavigationEnd } from "@angular/router";
import { BindComponentService } from '../../../utils/bind.component.service';

/**
 * $Id$
 * 
 * @author Thiago Neri
 * @version $Id: filename,v x.x.x.x YYYY/MM/DD hh:mm:ss uname Exp $
 */

@Component({
  selector: 'LoginComponent',
  templateUrl: './content.template.html'
})
export class LoginComponent implements OnInit {

  private isLoading: boolean = false;
  private isforgotMyPassword: boolean = false;
  private isChengePassword: boolean = false;
  private form: FormGroup;
  private isEmailSuccessfullySent: boolean = false;
  private isChengePasswordSuccess: boolean = false;
  private totalLogin: Number;
  private isGoLogin: boolean;
  private user: string;
  private account: string;
  private plan: string;

  ngOnInit() {

  
    let data = JSON.parse(localStorage.getItem('GET_AUTENTICATED_USER'));
    if (!isNil(data)) {
      this.user = data['user'];
    }

    if(!isNil(this.user)){
      this.redirect("/Portal/data/consumption");
    }

    this.form = this.formBuilder.group({
      email: ['', Validators.compose([Validators.required, Validators.pattern('^[a-zA-Z0-9.!#$%&’*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$')])],
      usuario: ['', Validators.compose([Validators.required, Validators.maxLength(80)])],
      senha: ['', Validators.compose([Validators.required, Validators.maxLength(80)])],
      novaSenha: ['', Validators.compose([Validators.required, Validators.maxLength(80)])],
      confirmarSenha: ['', Validators.compose([Validators.required, Validators.maxLength(80)])],
      senhaAntiga: ['', Validators.compose([Validators.required, Validators.maxLength(80)])],
    });
     function isNil(value) {
      return value == null;
     }
  }

  constructor(private bindComponent: BindComponentService,private authService: AuthenticationService, private router: Router, private alertService: AlertService, private formBuilder: FormBuilder) {

  }

  public redirect(andress:string){
    this.router.navigate([andress], { queryParams: {filter:false} });
  }


  private logar() {
    this.isLoading = true;
    this.isGoLogin = false;
      this.authService.login(this.form.controls['usuario'].value, this.form.controls['senha'].value).subscribe(
      data => {
        localStorage.setItem('GET_AUTENTICATED_USER',JSON.stringify(data));
        this.redirect("/Portal/data/consumption");
        this.isLoading = false;
        this.isChengePassword = false;
        localStorage.setItem("ALREADY_OPEN", "false");
        localStorage.setItem("HIBRID", "false");
        this.bindComponent.set(BindComponentService.IS_LOGIN_SUCESS, true);
      },
      err => {
        localStorage.setItem("ALREADY_OPEN", "false");
        localStorage.setItem("HIBRID", "false");
        this.alertService.error(err.result, err);
        this.isLoading = false;
        if (err.code === "EXPIRED") {
          this.isChengePassword = true;
        }
        this.isGoLogin = true;
      }
    );
  }
  
  public forgotMyPassword() {
    this.isforgotMyPassword = true;
  }

  public backToLogin() {
    this.isChengePassword = false;
    this.isforgotMyPassword = false;
    this.isEmailSuccessfullySent = false;
    this.isChengePasswordSuccess = false;
  }

  requestNewPassword() {
    this.isLoading = true;
    this.authService.requestNewPassword(this.form.controls['usuario'].value, this.form.controls['email'].value).subscribe(
      data => {
        this.isLoading = false;
        this.isforgotMyPassword = false;
        this.isEmailSuccessfullySent = true;
      },
      err => {
        this.isLoading = false;
        this.isEmailSuccessfullySent = false;
        this.alertService.error(err.result, err);
      }
    );
  }

  ChangePassword() {
    if (this.form.controls['novaSenha'].value === this.form.controls['confirmarSenha'].value) {
      this.isLoading = true;
      this.authService.ChangePassword(this.form.controls['usuario'].value, this.form.controls['novaSenha'].value, this.form.controls['senhaAntiga'].value).subscribe(
        data => {
          this.isLoading = false;
          this.isChengePasswordSuccess = true;
        },
        err => {
          this.isLoading = false;
          this.alertService.error(err.result, err);
        }
      )
    } else {
      this.alertService.error("A confirmação de senha não corresponde com a senha preenchida",null);
    }
  }

  public getTotalLogin() {
    return this.totalLogin;
  }
}




// WEBPACK FOOTER //
// ./src/app/home/paraEmpresas/login/content.component.ts